import { module } from 'angular';

import { default as fontResizeDirectiveName, FontResizeDirective } from './font-resize.directive';

export default module('contact.commons.toolbox.font-resize', []).directive(fontResizeDirectiveName, FontResizeDirective).name;
